import { Box, Button } from "@mui/material";
import React from "react";
import { AssociationObjectDetails } from "../../interfaces";
import { ModuleDropDown } from "../moduleDropDown";
import { CapitalizeString } from "../../utils";

export const LinkUnlinkEntity: React.FC<{
    entity: 'bom' | 'material' | 'document' | 'none',
    items: AssociationObjectDetails[],
    objectId?: string,
    objectType?: string,
    onUpdate: (itemsAdded: AssociationObjectDetails[], itemsRemoved: AssociationObjectDetails[]) => void
}> = ({
    entity = 'none',
    items = [],
    objectId,
    objectType,
    onUpdate = (itemsAdded, itemsRemoved) => false
}) => {

        const [item, setItem] = React.useState<AssociationObjectDetails[]>(items);

        const onUpdateBtnClicked = () => {            
            let currentItemIds = item.map(i => i._id);            
            let removedItems = items.filter(i => !currentItemIds.includes(i._id));
            onUpdate(item, removedItems);
        };

        return <Box>
            <ModuleDropDown
                label={entity === 'bom' ? 'BOM' : CapitalizeString(entity)}
                entity={entity}
                value={item ? item.map(_ => ({..._, value: _._id, label: `${_.sequence_id}-r${_.version}`})) : []}
                onChange={(option) => setItem(option as unknown as AssociationObjectDetails[])}
                isMulti
                objectId={objectId}
                objectType={objectType}
                versionHistorySelector
            />

            <Button
                fullWidth
                variant="contained"
                sx={{ marginTop: 2 }}
                onClick={(e) => onUpdateBtnClicked()}
            >Update</Button>
        </Box>
    }